'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactScrollUpButton = require('react-scroll-up-button');

var _reactScrollUpButton2 = _interopRequireDefault(_reactScrollUpButton);

var _BackToTop = require('./BackToTop.scss');

var _BackToTop2 = _interopRequireDefault(_BackToTop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackToTop = function (_PureComponent) {
    (0, _inherits3.default)(BackToTop, _PureComponent);

    function BackToTop() {
        (0, _classCallCheck3.default)(this, BackToTop);
        return (0, _possibleConstructorReturn3.default)(this, (BackToTop.__proto__ || (0, _getPrototypeOf2.default)(BackToTop)).apply(this, arguments));
    }

    (0, _createClass3.default)(BackToTop, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)(_reactScrollUpButton2.default, {
                ShowAtPostion: 1250,
                ContainerClassName: _BackToTop2.default['ScrollUpButton__Container'],
                TransitionClassName: _BackToTop2.default['ScrollUpButton__Toggled']
            }, void 0, (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)('div', {
                className: _BackToTop2.default.arrowWrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _BackToTop2.default.arrowUp
            })), (0, _jsx3.default)('div', {
                className: _BackToTop2.default.backToTopText
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'back_to_top_button'
            }))));
        }
    }]);
    return BackToTop;
}(_react.PureComponent);

exports.default = BackToTop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BacktoTop/BackToTop.js
// module id = BBIF
// module chunks = 57